var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "header" }, [
    _c(
      "div",
      { staticClass: "logo" },
      [
        _c("router-link", { attrs: { to: "/" } }, [
          _c("span", { staticClass: "header-logo" }),
          _vm._v(" "),
          _c("span", { staticClass: "header-title" }, [
            _vm._v(_vm._s(_vm.title) + " ")
          ])
        ])
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "right-menu" },
      [
        _c(
          "div",
          { staticClass: "badge" },
          [_c("svg-icon", { attrs: { "icon-class": "tip" } })],
          1
        ),
        _vm._v(" "),
        _c(
          "el-dropdown",
          { staticClass: "avatar-container right-menu-item hover-effect" },
          [
            _c(
              "div",
              { staticClass: "avatar-wrapper" },
              [
                _c("svg-icon", {
                  staticClass: "user-icon",
                  attrs: { "icon-class": "user" }
                }),
                _vm._v(" "),
                _c("span", { staticClass: "avatar-name" }, [
                  _vm._v(
                    "\n              " + _vm._s(_vm.cpy_name) + "\n          "
                  )
                ])
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-dropdown-menu",
              { attrs: { slot: "dropdown" }, slot: "dropdown" },
              [
                _c(
                  "router-link",
                  { attrs: { to: _vm.setting } },
                  [_c("el-dropdown-item", [_vm._v("我的账户")])],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-dropdown-item",
                  {
                    attrs: { divided: "" },
                    nativeOn: {
                      click: function($event) {
                        return _vm.logout($event)
                      }
                    }
                  },
                  [
                    _c(
                      "span",
                      [
                        _vm._v("\n              退出\n              "),
                        _c("svg-icon", { attrs: { "icon-class": "logout" } })
                      ],
                      1
                    )
                  ]
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-19c98e7a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-19c98e7a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layout/components/Header.vue
// module id = null
// module chunks = 